/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, ReactNode } from 'react';
import { Flex, Text, Box, Link as RebassLink, Image } from 'rebass';
import MainContainer from '../container/container';
import NavbarItem from './navbar-item';
import { graphql, useStaticQuery } from 'gatsby';
import { processMarkdown } from '../../utils/utils.js';
// import Search from './search';
import Search from '../../components/search/search.js';

import Link from '../link/link';

// @ts-ignore
import Logo from '../../assets/logos/Logo_no_tagline.png';

interface Props {
  className?: string;
  id?: string;
  children?: ReactNode;
  css?: any;
}

const Nav: FC<Props & JSX.IntrinsicElements['nav']> = ({
  className = '',
  id = '',
  children,
  ...rest
}) => {
  const {
    contentfulMenu: { linkList, announcementBar }
  } = useStaticQuery(
    graphql`
      query {
        contentfulMenu {
          announcementBar {
            ... on ContentfulAnnouncementBar {
              backgroundColor
              links {
                ... on ContentfulLinkButton {
                  id
                  styledAs
                  emphasis
                  slug
                  visibleText
                  newTab
                  color
                  internal {
                    type
                  }
                }
              }
            }
          }
          linkList {
            text
            slug
            id
            isDropdownCategory
            dropdownParent {
              id
              text
              slug
            }
          }
        }
      }
    `
  );

  // establish parent -> child relationship for easier iteration. Leave child -> parent in CMS as that is easier to edit when creating new links.
  linkList.map(link => {
    link.children = [];
    if (link.dropdownParent) {
      const parentItem = linkList.find(
        item => item.id === link.dropdownParent.id
      );
      parentItem.children.push(link);
    }
  });
  

  return (
    <Box
      sx={{
        ' @media screen and (max-width: 63.95em)': {
          display: 'none'
        }
      }}
    >
      {announcementBar && announcementBar.map(({text, links, backgroundColor}) => {
        let computedBackgroundColor;
        let computedTextColor;
      
        if (backgroundColor === 'White') {
          computedBackgroundColor = 'background';
          computedTextColor = 'text';
        } else if (backgroundColor === 'Fuschia') {
          computedBackgroundColor = 'fuschia';
          computedTextColor = 'background';
        } else if (backgroundColor === 'Purple') {
          computedBackgroundColor = 'purple';
          computedTextColor = 'background';
        } else if (backgroundColor === 'Teal') {
          computedBackgroundColor = 'primary';
          computedTextColor = 'text';
        } else {
          computedBackgroundColor = 'mustard';
          computedTextColor = 'text';
        }

        return (
          <Box bg={computedBackgroundColor} color={computedTextColor} width="100%">
            <MainContainer
              width="100%"
              sx={{
                paddingTop: '8px !important',
                paddingBottom: '8px !important',
                alignItems: 'center',
                position: 'relative'
              }}
            >
{/*               {text && text.text && (
                <Text dangerouslySetInnerHTML={{ __html: processMarkdown(text.text)}}
                  sx={{ color: computedTextColor, textAlign: 'left', '> * a': { color: 'white' } }} />
              )} */}

              <Box marginLeft='auto' width='300px'>
                <Search />
              </Box>
              {links && links.length > 0 && links.map(({ id, styledAs, emphasis, slug, visibleText, newTab, color }, i) => {
                let computedBackgroundColor;
                let computedTextColor;
              
                if (color === 'White') {
                  computedBackgroundColor = 'background';
                  computedTextColor = 'text';
                } else if (color === 'Fuschia') {
                  computedBackgroundColor = 'fuschia';
                  computedTextColor = 'background';
                } else if (color === 'Purple') {
                  computedBackgroundColor = 'purple';
                  computedTextColor = 'background';
                } else if (color === 'Teal') {
                  computedBackgroundColor = 'primary';
                  computedTextColor = 'text';
                } else {
                  computedBackgroundColor = 'mustard';
                  computedTextColor = 'text';
                }

                return (
                  <Link
                    styledAs={styledAs}
                    emphasis={emphasis}
                    key={`${id}-${i}`}
                    newTab={newTab}
                    bg={computedBackgroundColor}
                    {...(slug && { slug: slug })}
                    // ml={text && text.text ? 3 : 'auto' }
                    mb={[2, 0]}
                    flex={['0 1 100%', 1, 'unset']}
                    maxWidth={['100%', 'unset']}
                    sx={{ height: 'fit-content', ml: '10px', borderColor: computedBackgroundColor, color: computedTextColor }}
                    {...rest}
                  >
                    {visibleText}
                  </Link>
                )
              })}
            </MainContainer>
          </Box>
        )
      })}
      
      <Flex as="nav" alignItems="center">
        <MainContainer
          width="100%"
          justifyContent="space-between"
          sx={{
            paddingTop: '26px !important',
            paddingBottom: '16px !important'
          }}
        >
          <RebassLink my="auto" href="/" display="flex" sx={{ alignItems: 'center' }} data-gtm-link-track={`website-menu--logo`}>
            <Image
              src={Logo}
              alt="BootUp Professional Development Logo"
              sx={{ height: '75px' }}
            />
          </RebassLink>
          <Flex mt="auto">
            {linkList.map(
              ({
                slug,
                text,
                id,
                isDropdownCategory,
                children,
                dropdownParent
              }, i) => {
                return (
                  <NavbarItem
                    key={`${id}-${i}`}
                    dropdownChildren={children}
                    navItem={{ id, text, slug }}
                    isDropdownCategory={isDropdownCategory}
                    dropdownParent={dropdownParent}
                  />
                );
              }
            )}
          </Flex>
        </MainContainer>
      </Flex>
    </Box>
  );
};

export default Nav;
